import * as Yup from 'yup';

export default Yup.object().shape({
    email: Yup.string().email('Invalid Email').required('Email is required'),
});
